import { BaseText, Headline3, Meta, Spinner, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import styled from 'styled-components/native';
import { testIdentifiers } from 'utils/testIdentifiers';

const Container = styled.Pressable<{
  borderTop?: boolean;
  borderBottom?: boolean;
  padding: number;
}>`
  flex-direction: row;
  align-items: center;
  border-bottom-width: ${(p) => (p.borderBottom ? '3px' : '0px')};
  padding: ${({ padding }) => theme.normalising.heightPixel(padding)}px 0;
  width: 100%;

  ${(p) => (p.borderTop ? 'border-top-width: 3px;' : undefined)}
  border-top-color: ${(p) => p.theme.colors.gray50};
  border-bottom-color: ${(p) => p.theme.colors.gray50};
`;

const ItemWrapper = styled.View<{
  width?: string;
  alignRight?: boolean;
  marginRight?: string;
  justifyContent?: string;
}>`
  width: ${(p) => (p.width ? p.width + 'px' : 'auto')};
  flex: ${(p) => (p.alignRight ? '1 1 auto' : '0 1 auto')};
  flex-direction: row;
  justify-content: ${({ justifyContent = 'flex-end' }) => justifyContent};
  margin-right: ${(p) => (p.marginRight ? p.marginRight + 'px' : '0px')};
  align-items: center;
`;

const StyledText = styled(BaseText)<{ active: boolean }>`
  color: ${(p) =>
    p.active ? `${theme.colors.black}` : `${theme.colors.boost.red}`};
`;

type ZoneDetailsRowProps = {
  title: string;
  icon?: React.ReactNode;
  linkText?: string;
  linkColor?: string;
  onPress?: () => void;
  loading?: boolean;
  active?: boolean;
  rightItem?: React.ReactNode;
  borderTop?: boolean;
  testIDprefix?: string;
  borderBottom?: boolean;
  chevronStyle?: 'Down' | 'Right';
  chevronSize?: 's' | 'm' | 'l';
  chevronColor?: string;
  headlineTitle?: boolean;
  padding?: number;
  titleIcon?: React.ReactNode;
  displayChevronIcon?: boolean;
};

const ZoneDetailsRow = ({
  title,
  icon,
  linkText,
  linkColor = theme.colors.boost.green,
  onPress,
  loading = false,
  active = true,
  rightItem,
  borderTop = false,
  testIDprefix,
  borderBottom = true,
  chevronStyle = 'Right',
  chevronSize = 's',
  chevronColor = theme.colors.boost.green,
  headlineTitle = false,
  padding = 15,
  titleIcon,
  displayChevronIcon = true,
}: ZoneDetailsRowProps) => {
  const TitleComponent = headlineTitle ? Headline3 : StyledText;
  return (
    <Container
      padding={padding}
      style={({ pressed }: any) => [{ opacity: pressed ? 0.5 : 1 }]}
      onPress={onPress}
      borderTop={borderTop}
      borderBottom={borderBottom}>
      {loading ? (
        <Spinner small testID="spinner" />
      ) : (
        <>
          {icon && (
            <ItemWrapper width="20" marginRight="10">
              {icon}
            </ItemWrapper>
          )}
          <ItemWrapper
            justifyContent="space-between"
            marginRight="10"
            {...testIdentifiers(
              (testIDprefix as string) && `${testIDprefix}-title`
            )}>
            <TitleComponent active={active}>{title}</TitleComponent>
            {titleIcon}
          </ItemWrapper>
        </>
      )}
      <ItemWrapper
        alignRight
        {...testIdentifiers(
          (testIDprefix as string) && `${testIDprefix}-link`
        )}>
        {rightItem || <Meta color={linkColor}>{linkText}</Meta>}
        {displayChevronIcon && (
          <Icon
            name={`Chevron_${chevronStyle}`}
            size={chevronSize}
            color={chevronColor}
          />
        )}
      </ItemWrapper>
    </Container>
  );
};

export default ZoneDetailsRow;
